export function calculateStatChange(current, previous) {
  if (previous === null || previous === undefined) return null;

  if (previous === 0) {
    if (current === 0) return { label: 'No change', isPositive: true };
    return { label: current > 0 ? `+${current} new` : `${current}`, isPositive: current > 0 };
  }

  const pct = ((current - previous) / previous) * 100;

  return {
    label: `${pct > 0 ? '+' : ''}${pct.toFixed(1)}%`,
    isPositive: pct >= 0,
  };
}
